<template>
  <div>
    <b-row>
      <b-col cols="12">
        <d-select-input-search
          :options="clubs"
          :place-holder="$t('admin.duplicate.search-club-model')"
          class-name="bg-white mt-2 mb-3 w-75"
          icon="fa fa-search"
          @on:keydown="filterClubs($event)"
          @on:selected="onSelect"
        />
      </b-col>
      <b-col cols="4">
        <d-body-nav-bar
          :tabs="tabs"
          @tab-changed="onTabChange"
        />
      </b-col>
      <b-col cols="4" align="right">
        <d-button
          :text="check ? 'admin.duplicate.select-all' : 'admin.duplicate.unselect-all'"
          class="d-btn-sm d-btn btn d-btn-success font-text-title mt-1"
          @on:button-click="onCheckAll"
        />
      </b-col>
      <b-col align="right">
        <div class="has-search">
          <span class="fa fa-search form-control-feedback"></span>
          <input
            type="text"
            class="form-control"
            v-model="filter"
            :placeholder="$t('components.doinsport.table.search')"
          >
        </div>
      </b-col>
    </b-row>
    <d-table
      identifier="calendar"
      :tablefields="fields"
      :items="items"
      :per-page="itemsPerPage"
      :totalRows="totalRows"
      :is-busy="isBusy"
      :per-page-enabled="true"
      :tr-cursor-pointer="false"
      @per-page:update="onPerPageUpdate"
      @on:data-table-btn:checkbox="onDataTableCheck"
      @current-page:update="onPageUpdate"
    >
    </d-table>
    <div class="d-flex justify-content-end">
      <d-button
        :text="'admin.duplicate.proceed-to-edit'"
        class="d-btn-sm d-btn btn d-btn-success font-text-title mt-3"
        @on:button-click="onProceed"
      />
    </div>
  </div>
</template>
<script>
import {getClubs} from "@api/services/club/club.api";
import {getTimetables} from "@api/services/timetable/timetable.api";
import {getPricesByActivityType} from "@api/services/timetable/blocks/price/price.api";
import {cloneData} from "@/utils/form";

export default {
  data: () => ({
    items: [],
    clubs: [],
    filter: '',
    selectedClubId: '',
    selectedTab: 'formula',
    isBusy: false,
    check: false,
    timer: null,
    itemsPerPage: 10,
    totalRows: 1,
    currentPage: 1,
    tabs: [
      {name: 'admin.duplicate.menus.formula', active: true, id: 'formula'},
      {name: 'admin.duplicate.block-price.type.leisure', active: false, id: 'leisure'},
    ]
  }),
  props: {
    reload: {
      type: Boolean,
      default: false
    },
    filter: {
      type: String,
      default: ''
    },
    isArchived: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    reload: function () {
      this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
    },
    checkedBlockPrice: {
      deep: true,
      handler() {
        if (this.checkedBlockPrice?.activityType === 'formula') {
          this.tabs[0].active = true;
          this.tabs[1].active = false;
        } else {
          this.tabs[0].active = false;
          this.tabs[1].active = true;
        }
        this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
      }
    },
    filter: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
      }, 800);
    }
  },
  computed: {
    alignCellsToLeft() {
      return this.$store.getters['layout/getInnerWidth'] >= 991 ? 'text-center' : 'text-left';
    },
    clubList() {
      return this.$store.getters['club/getClubList']
    },
    checkedBlockPrice() {
      return this.$store.getters['blockPrice/getSelectedBlockPriceModel']
    },
    fields() {
      return [
        {
          key: "name",
          label: this.$t('admin.duplicate.shop-category.title'),
          sortable: true,
        },
        {
          key: "club.name",
          label: this.$t('admin.duplicate.shop-category.club'),
        },
        {
          key: "nextoreProduct.accountSale",
          label: this.$t('admin.duplicate.shop-category.account-sale'),
          class: "text-center"
        },
        {
          key: "actions",
          label: this.$t("general.actions.actions"),
        },
      ];
    },
    getCheckedCategoryList() {
      return this.$store.getters['blockPrice/getCheckedBlockPrices'];
    },
    getSelectedCalendar() {
      return this.$store.getters['blockPrice/getSelectedBlockPriceModel'];
    },
  },
  methods: {
    onTabChange($event) {
      this.selectedTab = $event.id;
      this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
    },
    onSelect($event) {
      if ($event === null) {
        this.selectedClubId = '';
        this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
      } else {
        this.selectedClubId = $event.item.id;

        this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
      }
    },
    onProceed() {
      this.$nextTick(() => {
        this.$router.push({name: 'duplicate_block_price', params: {type: this.selectedTab}});
      });
    },
    onDataTableCheck($event) {
      let getImpactedParks = this.$store.getters['blockPrice/getImpactedParks'];
      getImpactedParks === '' ? getImpactedParks = $event.club.name : getImpactedParks += ',' + $event.club.name;

      this.$store.commit('blockPrice/setImpactedParks', getImpactedParks);

      if ($event.checked) {
        this.$store.commit('blockPrice/addToBlockPricesList', $event)
      } else {
        this.$store.commit('blockPrice/removeFromBlockPriceCheckedList', $event)
      }
    },
    onCheckAll() {
      this.check = !this.check;

      for (const item of this.items) {
        item.checked = this.check;

        if (item.checked) {
          this.$store.commit('blockPrice/addToBlockPricesList', item)
        } else {
          this.$store.commit('blockPrice/removeFromBlockPriceCheckedList', item)
        }
      }
    },
    onPageUpdate(page) {
      this.loadBlockPrices(this.itemsPerPage, page, this.filter);
    },
    onPerPageUpdate(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.currentPage = 1;
      this.loadBlockPrices(itemsPerPage, this.currentPage, this.filter);
    },
    loadBlockPrices(itemsPerPage, currentPage, filter) {
      this.items = [];
      this.isBusy = true;

      getPricesByActivityType(itemsPerPage, currentPage, filter, this.selectedTab, this.selectedClubId)
        .then((response) => {
          this.totalRows = response.data['hydra:totalItems'];

          for (const item of response.data['hydra:member']) {
            item.actions = ['checkbox'];
            item.checked = false;

            this.items.push(item);
          }
        })
        .finally(() => {
          this.isBusy = false;
        })
      ;
    },
    filterClubs(filter) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadClubs(filter);
      }, 800);
    },
    loadClubs(filter = '') {
      getClubs(1, 30, filter)
        .then((response) => {
          this.clubs = [];

          this.$store.commit('club/setClubs', response.data['hydra:member']);

          for (const club of response.data['hydra:member']) {
            this.clubs.push({
              label: club.name,
              id: club.id,
              item: club,
              iri: club['@id'],
            });
          }
        })
      ;
    },
  },
  created() {
    this.clubs = cloneData(this.clubList);
    this.tabs[0].active = true;
    this.tabs[1].active = false;
    this.loadBlockPrices(this.itemsPerPage, this.currentPage, this.filter);
  }
}
</script>
<style scoped lang="scss">
@import "@lazy/_b-card.scss";

/deep/ .card .card-body {
  padding-left: 25px;
  padding-right: 25px;
}

/deep/ .page-item.active .page-link {
  z-index: 0;
  color: #fff;
  background-color: #092772;
  border-color: #092772;
}
</style>
